export default function Progress({ duration = 0, start }) {
  const date = new Date(start);
  const today = new Date();
  const diffTime = date > today ? 0 : Math.abs(date - today);
  const difference = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  const percentage =
    date > today ? 0 : Math.round(Math.min((difference / duration) * 100, 100));

  return (
    <div className="mb-4 h-6 w-full max-w-full rounded-full border bg-gray-100">
      <div
        className="flex h-full max-w-full items-center justify-center whitespace-nowrap rounded-full bg-casalucci px-4 text-center text-sm font-semibold text-white"
        style={{
          width: `${percentage}%`,
        }}
      >
        {`${percentage} %`}
      </div>
    </div>
  );
}
